import type { Action } from './IncomeReducer'

export enum Property {
  Type = 'type',
  Status = 'status',
  ContractType = 'contractType',
  StartDate = 'startDate',
  EndDate = 'endDate',
  ContractSchedule = 'contractSchedule',
  IncomeAmount = 'incomeProperties.value',
  IncomeFrequency = 'incomeProperties.frequency',
  IncomeHoursPerWeek = 'incomeProperties.averageHoursAWeek',
  HasGuaranteedBonus = 'hasGuaranteedBonus',
  BonusAmount = 'bonus.value',
  BonusFrequency = 'bonus.frequency',
  Company = 'company',
  CompanyAddressLine1 = 'address.line1',
  CompanyAddressLine2 = 'address.line2',
  CompanyAddressCity = 'address.city',
  CompanyAddressCounty = 'address.county',
  CompanyAddressPostCode = 'address.postcode',
  CompanyAddressCountry = 'address.country',
  Position = 'position',
  MeansType = 'meansType',
  PensionsProvider = 'pensionsProvider',
  Institution = 'institution',
  StudentIDNumber = 'idNumber',
}

export class PropertyDispatch {
  dispatch: React.Dispatch<Action>

  constructor(dispatch: React.Dispatch<Action>) {
    this.dispatch = dispatch
  }

  set(propertyPath: Property, payload: any) {
    this.dispatch({
      field: propertyPath,
      payload: payload,
    })
  }
}
